//include 9
jQuery(function(){

    $(".tabmosaic.paginationUsed").each((index, element) => {
       var $element = $(element);
       var parent = $element.closest(".tabmosaic-wrapper");
       if(parent.length == 0){
           return;
       }
       window.pixelpoint.ppComponents.module.reload(parent);
        parent.on("click", ".result-pagination li a", function(e){
            e.preventDefault();
            var $this = $(this);
            var href = $this.attr("href");
            var parsed = window.pixelpoint.utilities.parseUrl(href);
            var page = parsed.queryParameters.page || 1;

            var getParams = parent.data("get-params") || {};
            getParams.page = page;
            parent.data("get-params",getParams);
            window.pixelpoint.ppComponents.module.reload(parent);
        });
    })
});